import { defineComponent, h } from '@vue/composition-api';
import LoadingOutlined from '@kibt/meta-ui-icons/es/icons/LoadingOutlined';
import { withInstall } from '../util/index.js';

var Loading = defineComponent({
  name: 'm-loading',
  props: {
    color: {
      type: String,
      "default": null
    },
    fontSize: {
      type: String,
      "default": ''
    }
  },
  emits: ['click'],
  setup: function setup(props, context) {
    return function () {
      return h("div", {
        "class": 'm-loading',
        "style": {
          color: props.color || '',
          fontSize: props.fontSize || ''
        }
      }, [h(LoadingOutlined)]);
    };
  }
});
withInstall(Loading);

export { Loading as default };
//# sourceMappingURL=index.js.map
